// eslint-disable-next-line import/prefer-default-export
export const AUDIT_EVENT_KINDS = {
  ADDED: 'resourceAdded',
  DELETED: 'resourceDeleted',
  RECOVERED: 'resourceRecovered',
  UPDATED: 'updated',
};
